export default __webpack_public_path__ + "static/media/aliceferreiraaa_.e5aa81f0.jpg";